/** What a door produced, for the caller to announce. Prose belongs to the surface, not here. */
export type WriteOutcome = Readonly<{
  ok: boolean;
  /** Null where the refusal carried nothing brandable and the surface owns the wording. */
  message: string | null;
}>;

export const landed = (message: string): WriteOutcome => ({ ok: true, message });

export const refused = (message: string | null): WriteOutcome => ({ ok: false, message });
